import React, { Ref, forwardRef } from 'react';
import {
  Control,
  FieldErrors,
  FieldValues,
  RegisterOptions,
  UseFormWatch,
} from 'react-hook-form';
import { Controller } from 'react-hook-form';

import Description from '../description/Description';
import { InputFormatProps } from '../inputs/InputFormat';

export type InputHookProps = {
  type: 'number' | 'tel' | 'numberRound' | 'number-only';
  name: string;
  description?: string | React.ReactNode;
  control: Control<any>;
  rules?: RegisterOptions;
  errors?: FieldErrors<any>;
  placeholder?: string;
  maxLength?: number;
  styleWidthSize?: string;
  watch?: UseFormWatch<FieldValues>;
};

export type ExtendedProps = InputHookProps & InputFormatProps;

export default function withFormatHookForm(
  Component: React.ForwardRefExoticComponent<
    Omit<InputFormatProps, 'ref'> & React.RefAttributes<HTMLElement>
  >,
) {
  const WrappedComponent = forwardRef(
    (
      {
        type,
        name,
        errors,
        description,
        control,
        rules,
        readOnly,
        disabled,
        styleWidthSize,
        maxLength,
        watch,
        ...props
      }: ExtendedProps,
      ref: Ref<HTMLElement>,
    ) => {
      const hasError = !!errors?.[name];

      return (
        <>
          <div className="flex-1">
            <Controller
              control={control}
              name={name}
              rules={rules}
              render={({ field: { value, onChange } }) => {
                return (
                  <Component
                    ref={ref}
                    type={type}
                    name={name}
                    value={value}
                    readOnly={readOnly}
                    disabled={disabled}
                    hasError={hasError}
                    styleWidthSize={styleWidthSize}
                    onChange={onChange}
                    {...props}
                  />
                );
              }}
            />
            <Description
              name={name}
              errors={errors}
              description={description}
              watch={watch}
              maxLength={maxLength}
              styleWidthSize={styleWidthSize}
            />
          </div>
        </>
      );
    },
  );

  return WrappedComponent;
}
